import LegalPageLayout from "@/components/LegalPageLayout";
import SEO from "@/components/SEO";

export default function ComplaintsProcedure() {
  return (
    <>
      <SEO
        title="Complaints Procedure | YourSolicitor.co.uk"
        description="How to make a complaint about our services. We aim to acknowledge within 3 working days and resolve within 8 weeks. Regulated by the SRA."
        canonical="/complaints-procedure"
        noIndex={false}
      />
      <LegalPageLayout title="Complaints Procedure" lastUpdated={null}>
      <p className="legal-intro">How to make a complaint about our services.</p>

      <h2>Our Commitment to You</h2>
      <p>
        We are committed to providing excellent service. However, if something goes wrong, we want to know about it so we can put things right. As a firm regulated by the Solicitors Regulation Authority (SRA), we take all complaints seriously. We will investigate your complaint thoroughly and respond promptly.
      </p>

      <h2>How to Make a Complaint</h2>
      <div className="legal-contact-box">
        <div className="legal-contact-item"><strong>Email:</strong> <a href="mailto:complaints@bluelionclaims.co.uk">complaints@bluelionclaims.co.uk</a></div>
        <div className="legal-contact-item"><strong>Phone:</strong> 0208 153 0033</div>
        <div className="legal-contact-item">
          <strong>Post:</strong><br />
          Complaints Team<br />
          Blue Lion Law Limited<br />
          The Centro Buildings<br />
          20-23 Mandela Street<br />
          London, NW1 0DU
        </div>
      </div>

      <h2>What to Include in Your Complaint</h2>
      <p>To help us investigate, please include:</p>
      <ul>
        <li>Your full name and contact details</li>
        <li>Your reference number (if you have one)</li>
        <li>A clear description of what went wrong</li>
        <li>When the problem occurred</li>
        <li>What you would like us to do to resolve it</li>
        <li>Any relevant documents or correspondence</li>
      </ul>

      <h2>What Happens Next</h2>
      <div className="legal-steps">
        <div className="legal-step">
          <div className="legal-step-num">1</div>
          <div>
            <strong>Acknowledgement</strong>
            <p>We will acknowledge your complaint within 3 working days.</p>
          </div>
        </div>
        <div className="legal-step">
          <div className="legal-step-num">2</div>
          <div>
            <strong>Investigation</strong>
            <p>We will investigate your complaint thoroughly, which may involve reviewing your file and speaking with relevant staff.</p>
          </div>
        </div>
        <div className="legal-step">
          <div className="legal-step-num">3</div>
          <div>
            <strong>Response</strong>
            <p>We aim to provide a full written response within 8 weeks of receiving your complaint.</p>
          </div>
        </div>
      </div>

      <h2>If You Are Not Satisfied</h2>
      <p>If you are not satisfied with our response, or if we have not resolved your complaint within 8 weeks, you may refer your complaint to the Legal Ombudsman.</p>

      <h2>Legal Ombudsman</h2>
      <p>The Legal Ombudsman investigates complaints about solicitors and other legal service providers.</p>
      <div className="legal-contact-box">
        <div className="legal-contact-item"><strong>Website:</strong> <a href="https://www.legalombudsman.org.uk" target="_blank" rel="noreferrer">www.legalombudsman.org.uk</a></div>
        <div className="legal-contact-item"><strong>Email:</strong> <a href="mailto:enquiries@legalombudsman.org.uk">enquiries@legalombudsman.org.uk</a></div>
        <div className="legal-contact-item"><strong>Phone:</strong> 0300 555 0333</div>
        <div className="legal-contact-item"><strong>Post:</strong> Legal Ombudsman, PO Box 6167, Slough, SL1 0EH</div>
        <div className="legal-contact-item"><strong>Time limit:</strong> Normally you must bring your complaint to the Legal Ombudsman within 6 months of our final response.</div>
      </div>

      <h2>Solicitors Regulation Authority (SRA)</h2>
      <p>If you believe we have breached the SRA's rules or principles, you can report us to the SRA. However, the SRA is not able to award compensation or deal with complaints about poor service.</p>
      <div className="legal-contact-box">
        <div className="legal-contact-item"><strong>Website:</strong> <a href="https://www.sra.org.uk" target="_blank" rel="noreferrer">www.sra.org.uk</a></div>
      </div>

      <div className="legal-key-timeframes">
        <h3>Key Timeframes</h3>
        <p>Acknowledgement within <strong>3 working days</strong> and full written response target within <strong>8 weeks</strong>.</p>
      </div>

      <h2>Contact Our Complaints Team</h2>
      <div className="legal-contact-box">
        <div className="legal-contact-item"><strong>Email:</strong> <a href="mailto:complaints@bluelionclaims.co.uk">complaints@bluelionclaims.co.uk</a></div>
        <div className="legal-contact-item"><strong>Phone:</strong> 0208 153 0033</div>
      </div>
    </LegalPageLayout>
    </>
  );
}
